import { motion } from "framer-motion";
import { Phone, ArrowDown } from "@phosphor-icons/react";
import { SITE, IMAGES } from "@/constants/site";

export default function Hero({ onEnquire }) {
  return (
    <section id="top" data-testid="hero-section" className="relative flex min-h-[92vh] items-end overflow-hidden">
      <img
        src={IMAGES.hero}
        alt="Adani Shantigram luxury residences, Ahmedabad"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/30 to-black/10" />
      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 pb-24 pt-44 lg:px-12">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="text-xs font-semibold uppercase tracking-[0.3em] text-gold"
        >
          VR Ahmedabad Realtors · Adani Shantigram & SG Highway Specialists
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.25 }}
          className="mt-6 max-w-3xl font-serif text-4xl tracking-tighter text-white sm:text-5xl lg:text-7xl"
        >
          Luxury Real Estate Advisory in Ahmedabad
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mt-6 max-w-xl text-base text-white/85 sm:text-lg"
        >
          Premium apartments, penthouses, villas and commercial property across Adani Shantigram, SG Highway and the
          GIFT City corridor — new bookings, resale, rentals and investment guidance.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.55 }}
          className="mt-10 flex flex-wrap items-center gap-4"
        >
          <button
            data-testid="hero-enquire-btn"
            onClick={onEnquire}
            className="group flex items-center gap-2 rounded-sm bg-gold px-8 py-4 text-sm font-bold uppercase tracking-widest text-forest transition-colors duration-200 hover:bg-[#d4b274]"
          >
            Get Price & Floor Plans
            <ArrowDown size={16} weight="bold" className="transition-transform duration-200 group-hover:translate-y-0.5" />
          </button>
          <a
            href={`tel:${SITE.phoneRaw}`}
            data-testid="hero-call-btn"
            className="flex items-center gap-2 rounded-sm border border-white/40 px-8 py-4 text-sm font-bold uppercase tracking-widest text-white backdrop-blur-sm transition-colors duration-200 hover:border-gold hover:text-gold"
          >
            <Phone size={16} weight="fill" />
            {SITE.phoneDisplay}
          </a>
        </motion.div>
      </div>
    </section>
  );
}
